import { Drawer } from '@mantine/core';
import { Formik } from 'formik';
import { FormWithButtons } from '@flexinet/ui-components';
import { Contact, ContactStatus } from '../types';
import { FormComponent } from '../forms/FormComponent';
import { RecordSchema } from '../forms/RecordSchema';

interface AddContactDrawerProps {
    opened: boolean;
    onClose: () => void;
    initialValues?: Partial<Contact>;
    onSubmit: (values: Contact) => void;
}

export const AddContactDrawer = ({ opened, onClose, initialValues, onSubmit }: AddContactDrawerProps) => {
    const record = {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        company: '',
        position: '',
        notes: '',
        status: ContactStatus.ACTIVE,
        ...initialValues,
    } as Contact;

    const handleFormSubmit = (values: Contact) => {
        onSubmit(values);
        onClose();
    };

    return (
        <Drawer opened={opened} onClose={onClose} title="Add Contact" position="right" size="xl">
            <Formik
                initialValues={record}
                validationSchema={RecordSchema}
                onSubmit={handleFormSubmit}
                enableReinitialize
            >
                {({ handleSubmit, isSubmitting, ...rest }) => (
                    <FormWithButtons
                        handleSubmit={handleSubmit}
                        isSubmitting={isSubmitting}
                        handleCancel={onClose}
                        debug={false}
                        {...rest}
                    >
                        <FormComponent />
                    </FormWithButtons>
                )}
            </Formik>
        </Drawer>
    );
};
